var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"d-login-btn",attrs:{"type":_vm.type,"size":"medium","disabled":_vm.isDisable},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(this.buttonTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }